// LE
import lePinDefault from './lpcDefault.svg'
import lePinPreviewed from './lpcViewed.svg'

// Bedbank on LE
import leBedbankPinDefault from './bedbankDefault.svg'
import leBedbankPinPreviewed from './bedbankViewed.svg'

// Flash on LE
import leFlashPinDefault from './flashDefault.svg'
import leFlashPinPreviewed from './flashViewed.svg'
import selectedMarker from './selectedMarker.svg'
import flashSoldOutDefault from './flashSoldOutDefault.svg'
import flashSoldOutViewed from './flashSoldOutViewed.svg'

// Sold out
import soldOutPinDefault from './soldOutDefault.svg'
import soldOutPinDefaultHover from './soldOutDefaultHover.png'
import soldOutPinActive from './soldOutSelected.svg'
import soldOutPinPreviewed from './soldOutViewed.svg'
import soldOutPinPreviewedHover from './soldOutPreviewedHover.png'

// LED (placeholder)
import pinUnbranded from './pinDefault.png'
import pinUnbrandedActive from './pinActive.png'

export interface PinSizing {
  size: [number, number]
  anchor: [number, number]
}

interface Pin {
  image: string
  sizing: PinSizing
}

interface PinType {
  default: Pin
  hover: Pin
}

interface PinConfig {
  pinIcons: {
    default: PinType
    active: PinType
    previewed: PinType
  }
  flashPinIcons: {
    default: PinType
    active: PinType
    previewed: PinType
  }
  bedbankPinIcons: {
    default: PinType
    active: PinType
    previewed: PinType
  }
  soldOutPinIcons: {
    default: PinType
    active: PinType
    previewed: PinType
  }
  flashSoldOutPinIcons: {
    default: PinType
    active: PinType
    previewed: PinType
  }
}

const leDefaultSize: PinSizing = {
  // [width, height]
  size: [38, 48],

  // [left, top]
  anchor: [20, 55],
}

const selectedMarkerSize: PinSizing = {
  size: [44, 55],
  anchor: [22, 59],
}

const flashSoldOutMarkerSize: PinSizing = {
  size: [68, 80],
  anchor: [35, 68],
}

const bedbankDefaultSize: PinSizing = {
  size: [35, 43],
  anchor: [18, 40],
}

const bedbankExpandSize: PinSizing = {
  size: [39, 48],
  anchor: [20, 45],
}

const soldOutDefaultSize: PinSizing = {
  size: [32, 38],
  anchor: [16, 24],
}

const soldOutExpandSize: PinSizing = {
  size: [36, 43],
  anchor: [18, 29],
}

const unbrandedSize: PinSizing = {
  size: [28, 31],
  anchor: [14, 28],
}

const unbrandedSmallSize: PinSizing = {
  size: [18, 20],
  anchor: [9, 18],
}

const brandPins: { [brand: string]: PinConfig } = {
  luxuryescapes: {
    pinIcons: {
      default: {
        default: {
          image: lePinDefault,
          sizing: leDefaultSize,
        },
        hover: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
      },
      active: {
        default: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
        hover: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
      },
      previewed: {
        default: {
          image: lePinPreviewed,
          sizing: leDefaultSize,
        },
        hover: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
      },
    },
    flashPinIcons: {
      default: {
        default: {
          image: leFlashPinDefault,
          sizing: leDefaultSize,
        },
        hover: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
      },
      active: {
        default: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
        hover: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
      },
      previewed: {
        default: {
          image: leFlashPinPreviewed,
          sizing: leDefaultSize,
        },
        hover: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
      },
    },
    bedbankPinIcons: {
      default: {
        default: {
          image: leBedbankPinDefault,
          sizing: bedbankDefaultSize,
        },
        hover: {
          image: selectedMarker,
          sizing: bedbankExpandSize,
        },
      },
      active: {
        default: {
          image: selectedMarker,
          sizing: bedbankExpandSize,
        },
        hover: {
          image: selectedMarker,
          sizing: bedbankExpandSize,
        },
      },
      previewed: {
        default: {
          image: leBedbankPinPreviewed,
          sizing: bedbankDefaultSize,
        },
        hover: {
          image: selectedMarker,
          sizing: bedbankExpandSize,
        },
      },
    },
    soldOutPinIcons: {
      default: {
        default: {
          image: soldOutPinDefault,
          sizing: soldOutDefaultSize,
        },
        hover: {
          image: soldOutPinDefaultHover,
          sizing: soldOutExpandSize,
        },
      },
      active: {
        default: {
          image: soldOutPinActive,
          sizing: soldOutExpandSize,
        },
        hover: {
          image: soldOutPinActive,
          sizing: soldOutExpandSize,
        },
      },
      previewed: {
        default: {
          image: soldOutPinPreviewed,
          sizing: soldOutDefaultSize,
        },
        hover: {
          image: soldOutPinPreviewedHover,
          sizing: soldOutExpandSize,
        },
      },
    },
    flashSoldOutPinIcons: {
      default: {
        default: {
          image: flashSoldOutDefault,
          sizing: flashSoldOutMarkerSize,
        },
        hover: {
          image: selectedMarker,
          sizing: soldOutExpandSize,
        },
      },
      active: {
        default: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
        hover: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
      },
      previewed: {
        default: {
          image: flashSoldOutViewed,
          sizing: flashSoldOutMarkerSize,
        },
        hover: {
          image: selectedMarker,
          sizing: selectedMarkerSize,
        },
      },
    },
  },
  default: {
    pinIcons: {
      default: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSize,
        },
      },
      active: {
        default: {
          image: pinUnbrandedActive,
          sizing: unbrandedSize,
        },
        hover: {
          image: pinUnbrandedActive,
          sizing: unbrandedSize,
        },
      },
      previewed: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSize,
        },
      },
    },
    flashPinIcons: {
      default: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
      active: {
        default: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
      },
      previewed: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
    },
    bedbankPinIcons: {
      default: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
      active: {
        default: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
      },
      previewed: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
    },
    soldOutPinIcons: {
      default: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
      active: {
        default: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
      },
      previewed: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
    },
    flashSoldOutPinIcons: {
      default: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
      active: {
        default: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbrandedActive,
          sizing: unbrandedSmallSize,
        },
      },
      previewed: {
        default: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
        hover: {
          image: pinUnbranded,
          sizing: unbrandedSmallSize,
        },
      },
    },
  },
}

export default brandPins
